import { DescriptionText, FlexContainer, H1Text, H2Text, Hr } from "../../../../design";
import React from "react";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";
import getformatteddate from "../../../../utils/getformatteddate";

type Props = {
  payment: Object,
  bankImageUrl: String,
  cancelUrlLink: String,
}

const Header = (props: Props) => {
  const { payment, bankImageUrl, cancelUrlLink } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader 
      paymentCheckout={true} 
      bankImageUrl={bankImageUrl} 
      largeLogo={largeLogo}
      cancelUrlLink={cancelUrlLink}
    >
      <FlexContainer {...customContainerProps}>
        <H1Text {...customPrimaryHeadingProps}>
          Add Payment Method
        </H1Text>
        <Hr/>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Payment For
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {payment && payment.plan2 && payment.plan2.name}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Amount Payable
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {payment ? `${currencyformatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Next Plan Starts On
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {payment && payment.plan2StartDate && getformatteddate(payment.plan2StartDate)}
          </DescriptionText>
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
